module.exports = __webpack_public_path__ + "img/tokenBox23.df3e9e71.png";